import React from 'react';
import styles from '../Form.module.scss';

type PropsType = {
  children: React.ReactNode;
};

const ErrorField = (props: PropsType) => {
  return <div className={styles.errorField}>{props.children}</div>;
};

export default ErrorField;
